import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a85dca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectCourse = _resolveComponent("SelectCourse")!
  const _component_SelectChallenge = _resolveComponent("SelectChallenge")!
  const _component_SelectBookmark = _resolveComponent("SelectBookmark")!
  const _component_SelectCourseProblem = _resolveComponent("SelectCourseProblem")!
  const _component_SelectChallengeProblem = _resolveComponent("SelectChallengeProblem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "slide-fade-course" }, {
      default: _withCtx(() => [
        (_ctx.modalState === 'COURSE')
          ? (_openBlock(), _createBlock(_component_SelectCourse, {
              key: 0,
              onClickCourseCard: _ctx.onClickCourseCard
            }, null, 8, ["onClickCourseCard"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-fade-challenge" }, {
      default: _withCtx(() => [
        (_ctx.modalState === 'CHALLENGE')
          ? (_openBlock(), _createBlock(_component_SelectChallenge, {
              key: 0,
              onClickMiddleCl: _ctx.onClickMiddleCl
            }, null, 8, ["onClickMiddleCl"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-fade-bookmark" }, {
      default: _withCtx(() => [
        (_ctx.modalState === 'BOOKMARK')
          ? (_openBlock(), _createBlock(_component_SelectBookmark, {
              key: 0,
              onClickBookmark: _ctx.onClickBookmark
            }, null, 8, ["onClickBookmark"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-fade-bookmark" }, {
      default: _withCtx(() => [
        (_ctx.modalState === 'COURSE_PROBLEM')
          ? (_openBlock(), _createBlock(_component_SelectCourseProblem, {
              key: 0,
              onClickProblem: _ctx.onClickProblem
            }, null, 8, ["onClickProblem"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-fade-bookmark" }, {
      default: _withCtx(() => [
        (_ctx.modalState === 'CHALLENGE_PROBLEM')
          ? (_openBlock(), _createBlock(_component_SelectChallengeProblem, {
              key: 0,
              onClickProblem: _ctx.onClickProblem
            }, null, 8, ["onClickProblem"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}